import { api } from '@api/api2';

export const getSourceTypes = () => api.no_vers('get', 'information/dit/source_types');
